// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricesRouteImport } from './routes/prices'
import { Route as HelpRouteImport } from './routes/help'
import { Route as CreateRouteImport } from './routes/create'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as TemplatesTemplateIdRouteImport } from './routes/templates/$templateId'
import { Route as LoveSlugRouteImport } from './routes/love/$slug'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AdminSlugRouteImport } from './routes/admin/$slug'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricesRoute = PricesRouteImport.update({
            id: '/prices',path: '/prices',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const CreateRoute = CreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const TemplatesTemplateIdRoute = TemplatesTemplateIdRouteImport.update({
            id: '/templates/$templateId',path: '/templates/$templateId',getParentRoute: () => rootRouteImport
          })
const LoveSlugRoute = LoveSlugRouteImport.update({
            id: '/love/$slug',path: '/love/$slug',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AuthSigninRoute = AuthSigninRouteImport.update({
            id: '/auth/signin',path: '/auth/signin',getParentRoute: () => rootRouteImport
          })
const AdminSlugRoute = AdminSlugRouteImport.update({
            id: '/admin/$slug',path: '/admin/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRoute: AccountRoute,CreateRoute: CreateRoute,HelpRoute: HelpRoute,PricesRoute: PricesRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,AdminSlugRoute: AdminSlugRoute,AuthSigninRoute: AuthSigninRoute,BlogSlugRoute: BlogSlugRoute,LoveSlugRoute: LoveSlugRoute,TemplatesTemplateIdRoute: TemplatesTemplateIdRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)